// Initialize default values to state.

import { CurrencyCode } from '@types';
import {
  USIndexTopConstituentsState,
  USIndexTopConstituentsView,
} from '../types/us-top-constituent.type';

export const US_INDEX_TOP_CONSTITUENT_INITIAL_STATE: USIndexTopConstituentsState = {
  data: {
    asOfDate: null,
    tableData: null,
  },
  config: {
    currencyCode: CurrencyCode.USD,
    selectedTopConstituentView: USIndexTopConstituentsView.DAILY,
  },
};
